'use client'

import type { Address } from 'viem'

import { type ChainId, ChainUtils } from '@morpho-org/blue-sdk'
import { abbreviateAddress } from '@repo/utils'
import { memo, useMemo } from 'react'

import { ButtonLink } from '@/components/common/ButtonLink'

export interface UserCellExplorerProps {
  address: Address
  chainId: ChainId
}

/**
 * UserCellExplorer displays a user address with an external link to the block explorer.
 * Use this component when you want to link to Etherscan or other block explorers.
 */
const UserCellExplorer = ({ address, chainId }: UserCellExplorerProps) => {
  const formattedAddress = useMemo(() => abbreviateAddress(address), [address])

  return (
    <ButtonLink
      href={ChainUtils.getExplorerAddressUrl(chainId, address)}
      mode="external"
      buttonProps={{
        variant: 'ghost',
        size: 'default',
        label: formattedAddress,
        avatarProps: {
          address
        }
      }}
    />
  )
}

export default memo(UserCellExplorer)
